import { stringify } from 'qs'
import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchStories = (workspaceId) => {
  const queryString = stringify({
    'filter[brand_id]': workspaceId,
    include: 'brand',
    'page[limit]': 9999,
  })
  return HttpClient().get(`/stories/v2?${queryString}`)
}

const getStoriesV2 = (workspaceId) => async (dispatch) =>
  fetchStories(workspaceId)
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getStoriesV2
